import './SmsMultiApp.scss';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import * as S from '../scss/theme';

import HeaderTitle from '../comm/HeaderTitle';
import redux from '../reduxToolkit/redux';
import { useDispatch } from 'react-redux';
import { setHeaderInfo, setSelectedUnit_pdf } from '../reduxToolkit/redux';
import { Button } from '../comm/HongButton';
import SmsMulti_table from './SmsMulti_table';
import SmsMulti_sendMenu from './SmsMulti_sendMenu';


const SmsMultiApp = ({title, setIsModal_smsMulti, list_sms, setList_sms}) => {//LmsTecResultAttendByClass.js 이게 부모임 setList_sms

  useEffect(() => {

  }, []);

 
  function onSendMulti() {
    setIsModal_smsMulti(false);
  }
  

 

  //=========================================
  return (


    <S.Section>
    

      <div className="SmsMultiApp">
      <HeaderTitle title={title} direction={1} onBackClick={onSendMulti} />
        <SmsMulti_table list_sms={list_sms} setList_sms={setList_sms}/>
        <SmsMulti_sendMenu list_sms={list_sms} setList_sms={setList_sms}/>
      </div>


    </S.Section>

   

  

  );
};

export default SmsMultiApp;